<div class="routed-container">
  <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
    <div class="flex gap-2 items-center w-100">
      <a [routerLink]="['/venues']" class="back-button flex items-center justify-center gap-2 no-decoration">
        <i class="material-icons">arrow_back</i>
        <span>Back</span>
      </a>
      <h2 class="w-70 center-text">Venue Details</h2>
    </div>

    <!-- Basic Venue Details -->
    <ng-container *ngIf="venue; else basicVenueDetails">
      <ng-container *ngTemplateOutlet="basicVenueDetails"></ng-container>
    </ng-container>

    <!-- Loading State -->
    <ng-container *ngIf="loadingVenue">
      <div class="loader">
        <mat-spinner color="warn" [diameter]="50"></mat-spinner>
      </div>
    </ng-container>

    <!-- Tab Navigation -->
    <div class="card w-100 std-mt lg-mb" *ngIf="venue && !loadingVenue">
      <app-tabs
        [tabs]="tabs"
        [activeTab]="activeTab"
        (tabChange)="onTabChange($event)">
      </app-tabs>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Details Tab -->
        <div class="tab-pane" *ngIf="activeTab === 'details'">
          <ng-container *ngTemplateOutlet="venueDetails"></ng-container>
        </div>

        <!-- Address Tab -->
        <div class="tab-pane" *ngIf="activeTab === 'address'">
          <ng-container *ngTemplateOutlet="venueAddress"></ng-container>
        </div>

        <!-- Social Media Tab -->
        <div class="tab-pane" *ngIf="activeTab === 'social'">
          <ng-container *ngTemplateOutlet="venueSocial"></ng-container>
        </div>

        <!-- Settings Tab -->
        <div class="tab-pane" *ngIf="activeTab === 'settings'">
          <ng-container *ngTemplateOutlet="venueSettings"></ng-container>
        </div>
      </div>
    </div>

    <div class="card w-100 std-mb" *ngIf="venue">
      <app-agreement-section
      [sectionTitle]="'Associated Agreements'"
      [venue_id]="venue ? venue.kt_venue_id : null"
      [venue_name]="venue ? venue.name : null"
      [displayClientName]="true"
      ></app-agreement-section>
    </div>


  </div>
</div>


<!-- TEMPLATES -->
<ng-template #basicVenueDetails>
  <div class="flex card w-100" *ngIf="venue">
      <div class="flex justify-between items-center w-100">
        <div class="flex gap-2">
          <div class="venue-image-container">
            <div *ngIf="venue.venue_image" class="image-wrapper" (click)="uploadVenueImage()">
              <img [src]="venue.venue_image" class="profile-picture" />
              <div class="image-overlay">
                <i class="material-icons">edit</i>
                <span>Change Image</span>
              </div>
            </div>
            <div *ngIf="!venue.venue_image" class="image-placeholder" (click)="uploadVenueImage()">
              <i class="material-icons">add_photo_alternate</i>
              <span>Upload Image</span>
            </div>
            <span class="error-message" *ngIf="imageUploadError">{{ imageUploadError }}</span>
            <span class="success-message" *ngIf="imageUploading">Uploading...</span>
          </div>

          <div class="flex flex-col justify-center gap-2">
            <h2 class="no-m">
              <a href="{{'https://www.kingtrivia.com/venues/' + venue.slug}}" target="_blank" referrerpolicy="no-referrer">{{ venue.name }}</a>
            </h2>
          </div>
        </div>
        <button class="edit-button" (click)="openBasicVenueDetailsModal()">
          Edit
        </button>
      </div>
    </div>
</ng-template>

<ng-template #venueDetails>
  <div class="header-info">
    <h3>Venue Details</h3>
    <button class="edit-button" (click)="showEditModal('details')">
      Edit
    </button>
  </div>
  <div class="list-container">
    <div class="list-item">
      <strong>Venue URL</strong>
      <p><a href="{{venue.site_url}}" target="_blank" referrerpolicy="no-referrer">{{venue.site_url}}</a></p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Description</strong>
      <p [innerHTML]="venue.venue_description"></p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Phone</strong>
      <p>{{ venue.phone }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Email Address</strong>
      <p>{{ venue.email ? venue.email : '&mdash;' }}</p>
      <span class="spacer"></span>
    </div>
  </div>
</ng-template>

  <ng-template #venueAddress>
  <div class="header-info">
    <h3>Venue Address</h3>
    <button class="edit-button" (click)="showEditModal('address')">
      Edit
    </button>
  </div>
  <div class="list-container">
    <div class="list-item">
      <strong>Address</strong>
      <p>{{ venue.address }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>City</strong>
      <p>{{ venue.city }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>State</strong>
      <p>{{ venue.state }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Zip Code</strong>
      <p>{{ venue.zip_code }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Coordinates</strong>
      <p>{{ venue.latitude }}, {{ venue.longitude }}</p>
      <span class="spacer"></span>
    </div>
  </div>
 </ng-template>

<!-- Social Media Tab -->
<ng-template #venueSocial>
  <div class="header-info">
    <h3>Social Media</h3>
    <button class="edit-button" (click)="showEditModal('social')">
      Edit
    </button>
  </div>
  <div class="list-container">
    <div class="list-item">
      <strong>Facebook</strong>
      <p>{{ venue.facebook || '&mdash;' }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>X</strong>
      <p>{{ venue.twitter || '&mdash;' }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Instagram</strong>
      <p>{{ venue.instagram || '&mdash;' }}</p>
      <span class="spacer"></span>
    </div>
  </div>
</ng-template>

<!-- Settings Tab -->
<ng-template #venueSettings>
  <div class="header-info">
    <h3>Venue Settings</h3>
    <button class="edit-button" (click)="showEditModal('settings')">
      Edit
    </button>
  </div>
  <div class="list-container">
    <div class="list-item">
      <strong>Private Client</strong>
      <p>{{ venue.private_client ? 'Yes' : 'No' }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Testing/Training Venue</strong>
      <p>{{ venue.test_venue ? 'Yes' : 'No' }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Max Players</strong>
      <p>{{ venue.capacity }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Max Tables</strong>
      <p>{{ venue.tables }}</p>
      <span class="spacer"></span>
    </div>
    <div class="list-item">
      <strong>Zone</strong>
      <p>{{ venue.zone }}</p>
      <span class="spacer"></span>
    </div>
  </div>
</ng-template>

<!--  Basic Info Modal Contents -->
<ng-template #basicVenueDetailsContent>
  <div class="input-group">
    <label for="fname">Venue Name</label>
    <input type="text" [(ngModel)]="venueEditData.name" id="name" class="textbox p-10" />
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>


<!--  Details Modal Content -->
<ng-template #venueDetailsContent>
  <div class="input-group">
    <label for="fname">Venue URL</label>
    <input type="url" [(ngModel)]="venueEditData.site_url" id="website" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="fname">Description</label>
    <quill-editor
      [(ngModel)]="venueEditData.venue_description"
      [modules]="quillConfiguration"
      [placeholder]="''"></quill-editor>
  </div>
  <div class="input-group">
    <label for="fname">Phone</label>
    <input type="phone" [(ngModel)]="venueEditData.phone" id="phone" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="fname">Email Address</label>
    <input type="email" [(ngModel)]="venueEditData.email" id="email" class="textbox p-10" />
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>


<!--  Address Modal Content -->
<ng-template #venueAddressContent>
  <div class="input-group">
    <label for="address">Address</label>
    <input type="text" [(ngModel)]="venueEditData.address" id="address" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="city">City</label>
    <input type="text" [(ngModel)]="venueEditData.city" id="city" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="state">State</label>
    <input type="text" min="2" max="10" [(ngModel)]="venueEditData.state" id="state" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="zip">Zip Code</label>
    <input type="text" [(ngModel)]="venueEditData.zip_code" id="zip" class="textbox p-10" />
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>


<!--  Social Media Modal Content -->
<ng-template #venueSocialContent>
  <div class="input-group">
    <label for="facebook">Facebook</label>
    <input type="text" [(ngModel)]="venueEditData.facebook" id="facebook" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="x">X</label>
    <input type="text" [(ngModel)]="venueEditData.twitter" id="x" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="instagram">Instagram</label>
    <input type="text" [(ngModel)]="venueEditData.instagram" id="instagram" class="textbox p-10" />
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>

<!--  Settings Modal Content -->
<ng-template #venueSettingsContent>
  <div class="input-group">
    <label>Private Client</label>
    <div class="flex gap-4">
      <label>
        <input type="radio" [(ngModel)]="venueEditData.private_client" [value]="true" name="private_client" />
        Yes
      </label>
      <label>
        <input type="radio" [(ngModel)]="venueEditData.private_client" [value]="false" name="private_client" />
        No
      </label>
    </div>
  </div>

  <div class="input-group">
    <label for="zone">Zone</label>
    <input type="number" [(ngModel)]="venueEditData.zone" id="zone" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label for="maxplayers">Max Players</label>
    <input type="number" [(ngModel)]="venueEditData.capacity" min="0" max="1000" id="maxplayers" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label for="maxtables">Max Tables</label>
    <input type="number" [(ngModel)]="venueEditData.tables" min="0" max="1000" id="maxtables" class="textbox p-10" />
  </div>

  <div class="input-group">
    <label>Testing/Training Venue?</label>
    <div class="flex gap-4">
      <label>
        <input type="radio" [(ngModel)]="venueEditData.test_venue" [value]="true" name="test_venue" />
        Yes
      </label>
      <label>
        <input type="radio" [(ngModel)]="venueEditData.test_venue" [value]="false" name="test_venue" />
        No
      </label>
    </div>
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>





 <!-- MODALS -->
 <app-basic-modal *ngIf="editBasicVenueDetailsIsActive" [template]="basicVenueDetailsContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Venue'" [cancel]="'Close'"
  (doCancel)="editBasicVenueDetailsIsActive = false; modalErrorMessage = ''" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateBasicVenueData()" [disabled]="disableModalSaveButton">
</app-basic-modal>

 <app-basic-modal *ngIf="editVenueDetailsIsActive" [template]="venueDetailsContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Venue Details'" [cancel]="'Close'"
  (doCancel)="editVenueDetailsIsActive = false; modalErrorMessage = ''" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateVenueDetails()" [disabled]="disableModalSaveButton">
</app-basic-modal>

 <app-basic-modal *ngIf="editVenueAddressIsActive" [template]="venueAddressContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Venue Address'" [cancel]="'Close'"
  (doCancel)="editVenueAddressIsActive = false; modalErrorMessage = ''" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateVenueAddress()" [disabled]="disableModalSaveButton">
</app-basic-modal>

<!-- social media modal -->
 <app-basic-modal *ngIf="editVenueSocialIsActive" [template]="venueSocialContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Venue Social Media'" [cancel]="'Close'"
  (doCancel)="editVenueSocialIsActive = false; modalErrorMessage = ''" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateVenueSocial()" [disabled]="disableModalSaveButton">
</app-basic-modal>

<!-- settings modal -->
 <app-basic-modal *ngIf="editVenueSettingsIsActive" [template]="venueSettingsContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Venue Settings'" [cancel]="'Close'"
  (doCancel)="editVenueSettingsIsActive = false; modalErrorMessage = ''" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateVenueSettings()" [disabled]="disableModalSaveButton">
</app-basic-modal>
